import React, { useCallback, useEffect, useState } from 'react';
import { css } from '@emotion/react';
import SanityImage from 'gatsby-plugin-sanity-image';
import useEmblaCarousel from 'embla-carousel-react';
import Button from '../components/button';

export default function Gallery({
  className,
  images,
}) {
  const [activeGallery, setActiveGallery] = useState(null);
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    grab: false,
  });

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev()
  }, [emblaApi])

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext()
  }, [emblaApi])

  useEffect(() => {
    if (emblaApi) {
      emblaApi.scrollTo(activeGallery, true);
    }
  }, [emblaApi, activeGallery]);

  return (
    <div
      css={css`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: var(--gap);
        color: var(--black);
        margin-top: var(--gap);
        margin-bottom: var(--extraLargeMargin);
      `}
    >
      {images.map((image, i) => <div
        key={i}
        css={css`
          grid-column: span 1;
        `}
      >
        {image?.asset && <SanityImage
          css={css`
            cursor: pointer;

            &:hover {
              filter: invert(1);
            }
          `}
          onClick={() => setActiveGallery(i)}
          {...image}
          width={640}
        />}
      </div>)}
      {activeGallery !== null && <div>
        <div
          className="embla"
          css={css`
            position: fixed;
            inset: 0;
            background-color: rgba(255, 255, 255, 1);
            z-index: 1;
            overflow: hidden;
          `}
        >
          <div
            css={css`
              display: flex;
              justify-content: center;
              position: absolute;
              right: 0;
              bottom: 0;
              left: 0;
              padding: var(--margin);
              line-height: 0;
            `}
          >
            <Button
              onClick={() => scrollPrev()}
            >
              &larr;
            </Button>
            <Button
              onClick={() => setActiveGallery(null)}
            >
              &times;
            </Button>
            <Button
              onClick={() => scrollNext()}
            >
              &rarr;
            </Button>
          </div>
          <div
            ref={emblaRef}
            className="embla__viewport"
            css={css`
              height: 100%;
            `}
          >
            <div
              className="embla__container"
              css={css`
                display: flex;
                height: 100%;
              `}
            >
              {images.concat(images).map((image, i) => <div
                key={i}
                className="embla__slide"
                css={css`
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex: 0 0 calc(100% - calc(var(--margin) * 4));
                  height: 100%;
                  cursor: grab;
                `}
              >
                <div
                  css={css`
                    position: relative;
                    width: 100%;
                    height: calc(100vh - 180px);
                    padding: calc(var(--margin) / 2);
                  `}
                >
                  {image?.asset && <SanityImage
                    css={css`
                      width: 100%;
                      height: 100%;
                      object-fit: contain;
                      filter: drop-shadow(var(--shadow));
                    `}
                    {...image}
                    width={1980}
                    loading="eager"
                  />}
                  {image?.asset && <div
                    className="type--20"
                    css={css`
                      position: absolute;
                      bottom: var(--margin);
                      left: 0;
                      right: 0;
                      text-align: center;
                      padding: 0 var(--margin);
                      text-shadow:
                        0.5px 0.5px 1px rgba(255, 255, 255, 1),
                        -0.5px -0.5px 1px rgba(255, 255, 255, 1),
                        0.5px -0.5px 1px rgba(255, 255, 255, 1),
                        -0.5px 0.5px 1px rgba(255, 255, 255, 1)
                      ;
                    `}
                  >{image.asset.description}</div>}
                </div>
              </div>)}
            </div>
          </div>
        </div>
      </div>}
    </div>
  );
}
